import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { AllDataBreeding } from "../../../../api/breeding";
import { getDevicesForBuilding } from "../../../../utils/breedingDevices";
import { sectionToIcon } from "../../../type/default";
import { BuildingDevicesList } from "./BuildingDevicesList";

type FarmerBreedingCardProps = {
  data: AllDataBreeding;
  onSelect: () => void;
};

export const FarmerBreedingCard = ({
  data,
  onSelect,
}: FarmerBreedingCardProps) => {
  const { t } = useTranslation();
  const location = [data.breeding.city, data.breeding.zip_code]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      type="button"
      onClick={onSelect}
      className="group h-full w-full flex flex-col text-left bg-white rounded-xl overflow-hidden transition-all hover:scale-[1.01] focus:outline-none focus-visible:ring-2 focus-visible:ring-secondary"
      style={{
        boxShadow: "0px 4px 8px #b4b4b4",
      }}
    >
      <div className="flex items-center gap-3 px-4 py-3 bg-grey-light">
        <FontAwesomeIcon
          icon={sectionToIcon.section_breeding}
          className="text-tertiary"
        />
        <div className="flex-1 min-w-0">
          <div className="font-oxaniumMedium truncate">
            {data.breeding.name}
          </div>
          {location && (
            <div className="text-sm text-grey-medium truncate">{location}</div>
          )}
        </div>
        <FontAwesomeIcon
          icon="chevron-right"
          className="text-grey-medium transition-transform group-hover:translate-x-0.5"
        />
      </div>

      <div className="flex-1 flex flex-col gap-3 px-4 py-3">
        <div className="flex flex-wrap gap-x-4 gap-y-1 text-sm text-default-text">
          <span className="flex items-center gap-1.5">
            <FontAwesomeIcon
              icon={sectionToIcon.section_building}
              className="text-secondary"
            />
            {t("breeding-card-building-count", {
              count: data.buildings.length,
            })}
          </span>
          <span className="flex items-center gap-1.5">
            <FontAwesomeIcon
              icon={sectionToIcon.section_devices}
              className="text-secondary"
            />
            {t("breeding-card-device-count", { count: data.devices.length })}
          </span>
        </div>

        {data.buildings.length > 0 ? (
          <div className="space-y-2">
            {data.buildings.map((building) => (
              <div
                key={building.id}
                className="rounded-lg bg-grey-light/60 px-3 py-2"
              >
                <div className="flex items-center gap-2 mb-1.5">
                  <FontAwesomeIcon
                    icon={sectionToIcon.section_building}
                    className="text-secondary text-sm"
                  />
                  <span className="font-oxaniumMedium text-sm truncate">
                    {building.name}
                  </span>
                </div>
                <BuildingDevicesList
                  devices={getDevicesForBuilding(building, data.devices)}
                  compact
                />
              </div>
            ))}
          </div>
        ) : (
          <p className="text-sm text-grey-medium">
            {t("breeding-card-no-building")}
          </p>
        )}
      </div>
    </button>
  );
};
